/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {WebStorage as ɵb} from './lib/utility/storage/cookies-storage';
export {WebStorageUtility as ɵa} from './lib/utility/webstorage.utility';